import { Card, Collapse, Descriptions, Typography } from "antd"
import styles from "../styles.module.scss"
import Layout from "modules/layout/dashboard"
import { useTranslation } from "react-i18next"
import { useMember } from "../../../queries"
import { useMemberId } from "pages/member"
import { useAccidentId, useEventId } from "../.."
import Loader from "components/loader"
import parse from "html-react-parser"
import { useAccident, useEvent } from "../queries"
import { formatTimeToCurrentTimezone } from "utils/format-datetime"

const { Title } = Typography
const { Main } = Layout

const Accident: React.FC = () => {
  const { t } = useTranslation()
  const memberId = useMemberId()
  const member = useMember()
  const eventId = useEventId()
  const event = useEvent(eventId!, memberId!)
  const accidentId = useAccidentId()
  const { data, isLoading } = useAccident(memberId!, accidentId!)
  return (
    <div className={styles.container}>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Main.PageHeader
            breadcrumbs={[
              {
                title: member.data?.name,
                link: `/members/${member.data?.id}/events`,
              },
              {
                title: "Mes inscriptions",
                link: `/members/${member.data?.id}/events`,
              },
              {
                title: event.data?.name,
              },
              { title: "Accidents" },
            ]}
            title={
              <Title level={3}>{`Accident ${
                data?.accident_at
                  ? formatTimeToCurrentTimezone(data.accident_at)
                  : ""
              }`}</Title>
            }
          />
          <Card style={{ marginBottom: 15 }}>
            <Descriptions labelStyle={{ fontSize: 16 }} column={2}>
              <Descriptions.Item label={t("events.911_call")}>
                {data?.emergency ? t("global.yes") : t("global.no")}
              </Descriptions.Item>
              <>
                <Descriptions.Item label={t("events.respondent_call")}>
                  {data?.respondent?.contact.name}
                </Descriptions.Item>
                <Descriptions.Item label={t("events.911_comment")}>
                  {data?.emergency_comment}
                </Descriptions.Item>

                <Descriptions.Item label={t("events.respondent_comment")}>
                  {data?.respondent_note}
                </Descriptions.Item>
              </>
            </Descriptions>
          </Card>
          <Card>
            <Title style={{ marginBottom: 15 }} level={3}>
              {t("global.detail")}
            </Title>
            <Collapse>
              <Collapse.Panel header={t("accidents.accident_nature")} key="2">
                {data?.nature
                  ? parse(data?.displayed_nature!)
                  : t("global.no_data_display")}
              </Collapse.Panel>
              <Collapse.Panel
                header={t("accidents.situation_cause_consequence")}
                key="3"
              >
                {data?.situation
                  ? parse(data?.situation)
                  : t("global.no_data_display")}
              </Collapse.Panel>
              <Collapse.Panel
                header={t("accidents.interventions_performed")}
                key="4"
              >
                {data?.intervention
                  ? parse(data?.intervention)
                  : t("global.no_data_display")}
              </Collapse.Panel>
              <Collapse.Panel
                header={t("accidents.recommendations_followups")}
                key="5"
              >
                {data?.recommendation
                  ? parse(data?.recommendation)
                  : t("global.no_data_display")}
              </Collapse.Panel>
              <Collapse.Panel
                header={t("accidents.additional_informations")}
                key="6"
              >
                {data?.information
                  ? parse(data?.information)
                  : t("global.no_data_display")}
              </Collapse.Panel>
            </Collapse>
          </Card>
        </>
      )}
    </div>
  )
}

export default Accident
